/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_attributes_assortment = /** @type {(inputs: {}) => string} */ () => {
	return `Rozsah`
};

const da_attributes_assortment = /** @type {(inputs: {}) => string} */ () => {
	return `Sortiment`
};

const de_attributes_assortment = /** @type {(inputs: {}) => string} */ () => {
	return `Sortiment`
};

const en_attributes_assortment = /** @type {(inputs: {}) => string} */ () => {
	return `Assortment`
};

const es_attributes_assortment = /** @type {(inputs: {}) => string} */ () => {
	return `Rango`
};

const fr_attributes_assortment = /** @type {(inputs: {}) => string} */ () => {
	return `Gamme`
};

const hu_attributes_assortment = /** @type {(inputs: {}) => string} */ () => {
	return `Választék`
};

const it_attributes_assortment = /** @type {(inputs: {}) => string} */ () => {
	return `Assortimento`
};

const nl_attributes_assortment = /** @type {(inputs: {}) => string} */ () => {
	return `Assortiment`
};

const pl_attributes_assortment = /** @type {(inputs: {}) => string} */ () => {
	return `Zakres`
};

const pt_attributes_assortment = /** @type {(inputs: {}) => string} */ () => {
	return `Sortido`
};

const sv_attributes_assortment = /** @type {(inputs: {}) => string} */ () => {
	return `Sortiment`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const attributes_assortment = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.attributes_assortment(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("attributes_assortment", locale)
	if (locale === "cs") return cs_attributes_assortment(inputs)
	if (locale === "da") return da_attributes_assortment(inputs)
	if (locale === "de") return de_attributes_assortment(inputs)
	if (locale === "en") return en_attributes_assortment(inputs)
	if (locale === "es") return es_attributes_assortment(inputs)
	if (locale === "fr") return fr_attributes_assortment(inputs)
	if (locale === "hu") return hu_attributes_assortment(inputs)
	if (locale === "it") return it_attributes_assortment(inputs)
	if (locale === "nl") return nl_attributes_assortment(inputs)
	if (locale === "pl") return pl_attributes_assortment(inputs)
	if (locale === "pt") return pt_attributes_assortment(inputs)
	return sv_attributes_assortment(inputs)
};
export { attributes_assortment as "attributes.assortment" }